module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "aut"
  }, [_vm._v("The Berenson Family Decision-Making Rules")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('i', [_vm._v("If you are Jack, don’t assume the worst will happen. Imagine what Richard and Claire would do and then take out the life-threatening parts.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('i', [_vm._v("If you are Richard and Claire, don’t assume everything will be fine. Try to imagine what Jack would do. If Jack would never do what you’re thinking about doing, that is a warning sign!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('i', [_vm._v("If we all follow the rules, we will probably survive.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a922a26e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm2.vue
// module id = 72
// module chunks = 0